import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Download, X, Share, Smartphone } from "lucide-react";

const KEY = "agroterra_install_dismissed";
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isStandalone()) return;
    const dismissedAt = Number(localStorage.getItem(KEY) || 0);
    if (Date.now() - dismissedAt < 14 * 86400000) return;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIos()) setShow(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") setShow(false);
    setDeferred(null);
  };

  const dismiss = () => { localStorage.setItem(KEY, String(Date.now())); setShow(false); };

  if (!show) return null;
  return (
    <div data-testid="install-prompt" className="mb-8 rounded-2xl bg-[#143D29] text-emerald-50 p-5 flex flex-col sm:flex-row sm:items-center gap-4 relative overflow-hidden">
      <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full bg-[#52B788]/20" />
      <div className="h-12 w-12 rounded-2xl bg-[#52B788] text-[#143D29] flex items-center justify-center shrink-0"><Smartphone className="h-6 w-6" /></div>
      <div className="flex-1 min-w-0">
        <div className="font-display font-bold text-lg">Add AgroTerra to your home screen</div>
        <p className="text-sm text-emerald-100/80">Opens like a real app, loads faster, and your saved sheets work without signal.</p>
        {!deferred && isIos() && <p className="text-xs text-emerald-100/70 mt-1 flex items-center gap-1">Tap <Share className="h-3.5 w-3.5 inline" /> Share in Safari, then <b>Add to Home Screen</b>.</p>}
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {deferred && <Button data-testid="install-btn" onClick={install} className="bg-[#D97706] hover:bg-[#b45f05] text-white rounded-full px-5"><Download className="h-4 w-4 mr-2" /> Install</Button>}
        <button data-testid="install-dismiss-btn" onClick={dismiss} className="p-2 rounded-full hover:bg-white/10"><X className="h-4 w-4" /></button>
      </div>
    </div>
  );
}
